import { useMe } from "@/api/hooks";

/**
 * Фуллскрін-заглушка для адмін-забанених юзерів (юзер 2026-06-23).
 * Якщо `me.is_banned` — перекриває весь Mini App. Бот окремо відповідає
 * «Тебе заблоковано» на будь-яку дію.
 */
export function BannedScreen() {
  const me = useMe();
  if (!me.data?.is_banned) return null;

  return (
    <div className="fixed inset-0 z-[10001] flex flex-col items-center justify-center bg-bg px-8 text-center">
      <div
        className="mb-5 grid h-20 w-20 place-items-center rounded-[1.5rem] bg-danger/10 text-danger"
        aria-hidden
      >
        <svg
          width="38"
          height="38"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      </div>
      <div className="font-display text-[1.375rem] font-bold text-ink">
        Тебе заблоковано
      </div>
      <div className="mt-2 max-w-[18.75rem] text-[0.84375rem] leading-relaxed text-ink-dim [text-wrap:balance]">
        Доступ до inFLOW обмежено. Якщо вважаєш, що це помилка — звернись у
        підтримку.
      </div>
    </div>
  );
}
